import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStorage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="storage, hdd, ssd"><path d="M4.75 14.75H19.25M4.75 2.75H19.25V21.25H4.75V2.75ZM12.75 17.75H13.25V18.25H12.75V17.75ZM15.75 17.75H16.25V18.25H15.75V17.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconStorage;
